import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useEffect } from "react";
import { SaveIcon } from "../../icons/ButtonIcons";
import { MASTER_DATA_APIS } from "../../common/apis";

const headingMessage = "Select the products you wish to be Auto Evaluated and sent to Approval Screen.";
const successMessage = { color: "green", message: "Your Auto Eval Products have been updated" };
const errorMessage = { color: "purple", message: "No changes were made to your AutoEval products" };

export default function AutoEvalProducts() {
  const { get, post } = useFetch();

  const [checkedItems, setCheckedItems] = useState([]);
  const [infoMessage, setInfoMessage] = useState({})
  const [products, setProducts] = useState([]);

  useEffect(() => {
    (async function () {
      const response = await get(`${MASTER_DATA_APIS.GET_AUTOEVAL_PRODUCT}`);
      const p = response;
      setProducts(p);

      let a = p?.filter(i => i?.PushAutoEvaluateToApprove === true);
      if (a?.length > 0) {
        setCheckedItems(a);
      }
    })();
  }, []);

  function removeObjectWithId(arr, id) {
    const objWithIdIndex = arr.findIndex((obj) => obj.ProductId === id);
    if (objWithIdIndex > -1) {
      arr.splice(objWithIdIndex, 1);
    }
    return arr;
  }


  let compareTwoArrayOfObjects = (arr1, arr2) => {
    const res1 = arr1.filter((page1) => arr2.find(page2 => page1.PushAutoEvaluateToApprove !== page2.PushAutoEvaluateToApprove))
    return res1
  };

  const handleProductChange = (product, isChecked) => {
    removeObjectWithId(checkedItems, product?.ProductId);

    setCheckedItems((prevCheckedItems) => (
      [...prevCheckedItems,
      { ...product, "PushAutoEvaluateToApprove": isChecked, }
      ]));
  };

  const handleSaveClick = async () => {


    const payload = compareTwoArrayOfObjects(checkedItems, products);

    if (payload?.length > 0) {
      try {
        const result = await post(MASTER_DATA_APIS.EDIT_AUTOEVAL_PRODUCT, payload);
        if (result > 0) {
          setInfoMessage(successMessage);
        }
        else {
          setInfoMessage(errorMessage);
        }
      }
      catch {
        setInfoMessage(errorMessage);
      }
    }
  }

  return (
    <Grid container>
      <Grid item xs={12} sx={{ p: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600 }}>{headingMessage}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ color: infoMessage?.color || "" }}>{infoMessage?.message || ""}</Typography>
        </Grid>
        {products?.map((product) => {
          return (
            <Grid item xs={12} key={product.ProductId} sx={{ mt: 1 }}>
              <Box
                component="label"
                htmlFor={`product-eval-${product.ProductId}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "50%",
                  borderBottom: "1px solid rgb(224, 224, 224)",
                  borderRadius: "0",
                  cursor: "pointer",
                }}
              >
                <Checkbox
                  id={`product-eval-${product.ProductId}`}
                  name={product.Product}
                  checked={
                    checkedItems?.find(item => item?.ProductId === product.ProductId)
                      ?.PushAutoEvaluateToApprove === true
                  }
                  onChange={(e) => handleProductChange(product, e.target.checked)}
                  sx={{
                    color: "initial",
                  }}
                />
                <Box
                  sx={{
                    flex: 1,
                    backgroundColor:
                      checkedItems?.find(item => item?.ProductId === product.ProductId)
                        ?.PushAutoEvaluateToApprove === true
                        ? (product?.Colour || "green")
                        : "transparent",
                    color:
                      checkedItems?.find(item => item?.ProductId === product.ProductId)
                        ?.PushAutoEvaluateToApprove === true
                        ? "white"
                        : "initial",
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                >
                  <Typography variant="body1">
                    {product?.Product + (product.IsArchived ? "  :  Archived" : "")}
                  </Typography>
                </Box>
              </Box>

            </Grid>
          )
        })}
        <Grid item xs={12}>{checkedItems?.length > 0 ?
          <Button
            sx={{ ml: 50 }}
            startIcon={<SaveIcon />}
            variant="contained"
            onClick={handleSaveClick}
          >
            Save
          </Button> : <></>}
        </Grid>
      </Grid>
    </Grid>
  );
}
